window.merchantStoresData = [
    {
        title: "Lincolnshire Gun Shop",
        position: { lat: 53.210585, lng: -0.325392 },
        logo: "https://graph.facebook.com/LincolnshireGunShop/picture?type=large",
        time: "Mon Closed; Tue-Fri 10:00-17:00; Sat 10:00-15:00; Sun Closed",
        description: "Opened on 29th May 2018, Lincolnshire Gun Shop is a family owned business operated by G.B Skeet and Trap Supplies LTD, founded in 2008. With over 96 years combined experience, we provide quality firearms, accessories, and gunsmithing services with unbeatable customer service and after-sales support.",
        category: "Gunsmiths",
        image: "https://graph.facebook.com/LincolnshireGunShop/picture?type=large",
        address: "20 Station Road, Bardney, Lincolnshire, LN3 5UA",
        email: "chris@lincolnshiregunshop.co.uk",
        phone: "01526 397 788",
        website: "https://lincolnshiregunshop.co.uk/"
    },
    {
        title: "Donaldson Guns",
        position: { lat: 51.997343, lng: -0.715187 },
        logo: "https://www.donaldson-guns.co.uk/image/cache/catalog/logo-2481x434.jpg",
        time: "Mon-Fri 09:00-17:00; Sat 09:00-15:00; Sun Closed",
        description: "Established for over 20 years, we are a family run gun shop based in Milton Keynes and have over 70 years combined experience in the gun trade. No need for an appointment, you are welcome to visit us anytime during our opening hours. Here at Donaldson's our aim is to find the gun that is right for you.",
        category: "Gunsmiths",
        image: "https://www.donaldson-guns.co.uk/image/cache/catalog/slides/Home2-1280x500.jpg",
        address: "10 and 12 Wharfside, Fenny Stratford, Bletchley, Milton Keynes, Buckinghamshire, MK2 2AZ",
        email: "sales@donaldson-guns.co.uk",
        phone: "01908 377144",
        website: "https://www.donaldson-guns.co.uk/"
    },
    {
        title: "Hayley Dexis Belfast",
        position: { lat: 54.6265978, lng: -5.9146816 },
        logo: "https://hayley-group.co.uk/wp-content/uploads/2023/11/hayley_dexis_logo.svg",
        time: "Mon-Fri 08:30-17:30",
        description: "HAYLEY DEXIS Belfast is located on the Doncrue Industrial Estate, Belfast. The branch and trade counter stocks an extensive range of components and consumables including bearings, seals, power transmission, fluid power, drives, lubricants, PPE and tools.",
        category: "Engineering",
        image: "https://hayley-group.co.uk/wp-content/uploads/2024/10/branch-finder-938x400.jpg",
        address: "Duncrue Road, Duncrue Estate, Belfast, County Antrim, BT3 9BP",
        email: "belfast@hayley-group.co.uk",
        phone: "02890 371 130",
        website: "https://hayley-group.co.uk/"
    },
    {
        title: "Classic Firearms UK Ltd",
        position: { lat: 52.5647682, lng: 0.0667436 },
        logo: "https://img1.wsimg.com/isteam/ip/5b6e92eb-7f1a-45ba-91c9-5cbc7768a69e/Classic%20Firearms%20UK%20Ltd%20HEADER.png/:/rs=w:1443,h:320,cg:true,m/cr=w:1443,h:320/qt=q:95",
        time: "Mon-Fri 9:30-16:30",
        description: "Gunsmiths: Restoration, Repair and Servicing of guns with a particular interest in guns from the very late 19th century through to the late 20th century. American guns are our favourites.",
        category: "Gunsmith",
        image: "",
        address: "Unit C9 33 Thorby Avenue, March, Cambridgeshire, PE15 0BD",
        email: "info@classicfirearmsuk.co.uk",
        phone: "01354 651888",
        website: "https://classicfirearmsuk.co.uk"
    },
    {
        title: "Field and Stream",
        position: { lat: 54.4468873, lng: -6.689203 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/F_S-Ballistol-Dealers.png?v=1651939372",
        time: "Mon-Fri 9:00-18:00",
        description: "Your trusted dealer for field sports equipment.",
        category: "Field Sports",
        image: "",
        address: "24 Charlemont Street, Moy, Dungannon, County Tyrone, BT71 7SL",
        email: "info@fieldstream.com",
        phone: "028 8778 9533",
        website: "https://m.facebook.com/Fieldandstreamni/"
    },
    {
        title: "GR & RD Taylor Ltd",
        position: { lat: 54.2030333, lng: -2.5975704 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/GR_RD-Ballistol.png?v=1730550645",
        time: "Mon-Fri 9:00-17:00",
        description: "Kirkby Lonsdale's very own Aladdin's Cave as we have a Large and diverse range of stock",
        category: "Outdoor equipment shop",
        image: "https://images.squarespace-cdn.com/content/v1/666b0ae0599e5e0c895e6ff7/28a655a9-7f06-44da-a928-8d2220b908bd/20240617_214128+%283%29.jpg",
        address: "13-15 Market St, Kirkby Lonsdale, Carnforth LA6 2AU",
        email: "grrdtaylor@gmail.com",
        phone: "015242 71170",
        website: "https://www.facebook.com/westmorlandsurplus/?locale=en_GB"
    },
    {
        title: "Field and Falcon",
        position: { lat: 53.0816507, lng: -2.9228555 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/F_F-Ballistol-dealers.png?v=1651946200",
        time: "Mon-Fri 8:00-17:00",
        description: "Specialist in field sports and equipment.",
        category: "Field Sports",
        image: "https://lh5.googleusercontent.com/p/AF1QipPlWXrOEs1XvK_hFGSTlOG-OaRJDpgNjOtQLd_w=s1027-k-no",
        address: "Lodge Farm, Borras Road, Rossett, Wrexham, LL13 9TE",
        email: "info@fieldandfalcon.co.uk",
        phone: "01829 271431",
        website: "https://www.fieldandfalcon.co.uk"
    },
    {
        title: "Powys Guns",
        position: { lat: 52.682698, lng: -3.190381 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/PowysGuns-Ballistol-dealers.png?v=1652015190",
        time: "Mon-Fri 9:00-17:00",
        description: "Mid Wales' premier gun shop.",
        category: "Gun Shop",
        image: "",
        address: "The Lodge, Stone Cottage, Laundry Lane, Moel-Y-Garth, SY21 9JF",
        email: "info@powysguns.co.uk",
        phone: "01938 553278",
        website: "https://www.powysguns.co.uk"
    },
    {
        title: "BRYN DERW GUNS",
        position: { lat: 52.915003, lng: -4.050515 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/Bryn-Derw-guns-Ballistol-Dealers.png?v=1652015384",
        time: "Mon-Sat 9:00-17:00",
        description: "North Wales' trusted gun dealer.",
        category: "Gun Shop",
        image: "",
        address: "Bryn Derw, Talsarnau, Gwynedd, LL46 2GY",
        email: "info@brynderwguns.co.uk",
        phone: "07786 080 434",
        website: "https://brynderwguns.co.uk/en/"
    },
    {
        title: "CELTIC CORNER",
        position: { lat: 53.26339, lng: -4.091949 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/celtic-corner-Ballistol-Dealers.png?v=1652015469",
        time: "Mon-Fri 9:00-18:00",
        description: "A variety of sporting goods and equipment.",
        category: "Sports Shop",
        image: "",
        address: "26 Castle Street, Beaumaris, Anglesey, LL58 8AP",
        email: "info@celticcorner.com",
        phone: "01248 811 210",
        website: "https://celticcorner.business.site"
    },
    {
        title: "MCDERMID SUPPLY",
        position: { lat: 55.0765324, lng: -3.6019881 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/mcdermid-supply-company-Ballistol-Dealers.png?v=1652016071",
        time: "Mon-Fri 9:00-17:00",
        description: "Scotland's leading supply of gun and ammo.",
        category: "Gun Shop",
        image: "https://www.mcdermidsupply.co.uk/wp-content/uploads/2022/09/3500px-12-8-22-003.jpg",
        address: "13 Greystone Crescent, Dumfries, Scotland",
        email: "sales@mcdermidsupply.co.uk",
        phone: "01387 251 010",
        website: "https://mcdermidsupply.co.uk"
    },
    {
        title: "SUSSEX GUNS",
        position: { lat: 50.9110603, lng: 0.4350928 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/sussex-guns-Ballistol-Dealers.png?v=1652016236",
        time: "Mon-Sat 8:00-17:00",
        description: "Leading supplier of shooting equipment in Sussex.",
        category: "Gun Shop",
        image: "",
        address: "Caveswood Ltd, Model Farm, Normanhurst, Battle, East Sussex, TN33 9LS",
        email: "contact@sussexguns.co.uk",
        phone: "01424 773511",
        website: "https://www.sussexguns.com"
    },
    {
        title: "CAMBRIDGE GUN CLUB",
        position: { lat: 52.3178832, lng: 0.1856915 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/cambridge-gun-club-Ballistol-Dealers.png?v=1652017048",
        time: "Mon-Sun 9:00-18:00",
        description: "Premier shooting club in Cambridgeshire.",
        category: "Gun Club",
        image: "",
        address: "Cheap Fen Farm, Long Drove, Tottenham, Cambridgeshire, CB24 8AH",
        email: "info@cambridgegunclub.co.uk",
        phone: "01353 648004",
        website: "https://www.cambridgegunclub.co.uk"
    },
    {
        title: "C2 PRECISION",
        position: { lat: 50.5788283, lng: -3.661898 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/c2-Precision-Ballistol-Dealers.png?v=1652016753",
        time: "Mon-Fri 9:00-17:00",
        description: "High-precision firearms and equipment.",
        category: "Gun Shop",
        image: "",
        address: "Unit 13A Unit 1, Kingshill Industrial Estate, Bude, Cornwall, EX23 8QN",
        email: "info@c2precision.co.uk",
        phone: "01288 355775",
        website: "https://www.c2precision.co.uk"
    },
    {
        title: "WYE VALLEY GUNS",
        position: { lat: 52.0578032, lng: -3.2805013 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/WYE-Valley-Guns-Ballistol-Guns.jpg?v=1652019579",
        time: "Mon-Sat 9:00-17:00",
        description: "Expert firearms dealer in Wales.",
        category: "Gun Shop",
        image: "",
        address: "1 Tyn Y Caeu, Llanstephan, Brecon, LD3 0YU",
        email: "info@wyevalleyguns.co.uk",
        phone: "01874 455470",
        website: "https://wyevalleyguns.co.uk"
    },
    {
        title: "Steve Smiths Shooting Ground",
        position: { lat: 55.0651729, lng: -1.6822495 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/image0.jpg?v=1712860821",
        time: "Mon-Sun 9:00-18:00",
        description: "Newcastle's top shooting range.",
        category: "Shooting Ground",
        image: "",
        address: "Horton Grange Road, Dinnington, Newcastle, NE13 7AB",
        email: "shoot@stevesmiths.co.uk",
        phone: "01661 822 444",
        website: "http://www.stevesmiths.co.uk"
    },
    {
        title: "Arms Restoration Services",
        position: { lat: 51.9418617, lng: 0.9058397 },
        logo: "https://cdn.shopify.com/s/files/1/0568/7525/3942/files/Arms_Restoration_Services.png?v=1695310474",
        time: "Mon-Fri 9:00-17:00",
        description: "Restoration services for all firearms.",
        category: "Restoration Services",
        image: "",
        address: "60 Straight Road, Boxted, Colchester, Essex, CO4 5QY",
        email: "arthur-smith@btconnect.com",
        phone: "01206 272354",
        website: "mailto:arthur-smith@btconnect.com"
    },
    {
        title: "1967spud",
        position: { lat: 52.8028019, lng: 1.2631048 },
        logo: "https://1967spud.com/media/logo/websites/1/1967Spud_1.png",
        time: "Mon-Fri 9:00-17:00",
        description: "Reloading supplies and equipment.",
        category: "Reloading Supplies",
        image: "",
        address: "Units 12-14 Stumpy's Way, Ind. Est, Aylsham, Norfolk, NR11 6SS",
        email: "info@1967spud.com",
        phone: "01263 739923",
        website: "mailto:info@1967spud.com"
    },
    {
        title: "SOTEK RELOADING",
        position: { lat: 50.578828, lng: -3.661898 },
        logo: "https://www.sotekreloading.co.uk/wp-content/uploads/go-x/u/562f0192-0cf4-4b4c-8970-d4797a3a2ee7/image-384x145.jpg",
        time: "Mon-Fri 9:00-17:00",
        description: "Specialist reloading equipment.",
        category: "Reloading Supplies",
        image: "",
        address: "Old Newton Rd, Heathfield, Newton Abbot, TQ12 6UT, UK",
        email: "info@sotekreloading.co.uk",
        phone: "+44(0)7971 523894",
        website: "https://www.sotekreloading.co.uk"
    },
    {
        title: "M F Gotel Guns",
        position: { lat: 49.208, lng: -2.072 },
        logo: "",
        time: "",
        description: "Retailer of firearms and accessories based in Jersey.",
        category: "Gun Shop",
        image: "",
        address: "33 Le Jardin du Hogard, Maufant, St Martin, Jersey JE36JP",
        email: "Mauricegotel@gmail.com",
        phone: "07797 759447",
        website: "mailto:Mauricegotel@gmail.com"
    }
];
